import { useEffect } from "react";
import { Navigate, Outlet, useLocation, useParams } from "react-router";
import { useBuilding } from "../../context/BuildingContext";

export default function BuildingRequiredRoute() {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const { currentBuilding, buildings, isLoading, selectBuilding } = useBuilding();
  const buildingId = id ? Number(id) : currentBuilding?.id;
  // The server-provided collection is the authorization boundary. It includes
  // archived sites for administrators, while property-manager responses only
  // contain active assigned buildings.
  const authorizedBuilding = buildings.find((building) => building.id === buildingId);

  useEffect(() => {
    if (authorizedBuilding && currentBuilding?.id !== authorizedBuilding.id) {
      selectBuilding(authorizedBuilding);
    }
  }, [authorizedBuilding, currentBuilding?.id, selectBuilding]);

  // Show loading spinner while building data is being fetched
  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-brand-500 border-t-transparent"></div>
      </div>
    );
  }

  // Redirect to building selection if no building is selected
  if (!buildingId || !authorizedBuilding) {
    return <Navigate to="/sites" replace state={{ accessDenied: Boolean(id), from: location.pathname }} />;
  }

  if (currentBuilding?.id !== authorizedBuilding.id) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-brand-500 border-t-transparent"></div>
      </div>
    );
  }

  return <Outlet />;
}
